// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.main-container {
  padding: 20px;
  min-width: 400px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: calc(90vh - 40px);
}
.main-container h3 {
  margin: 0 0 20px 0;
  color: #707070;
  font-size: 18px;
  font-weight: 600;
}
.main-container .input-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;
}
.main-container .input-container .textarea-mat-field {
  width: 100%;
}
.main-container .action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 12px;
  border-top: 1px solid #e0e0e0;
}
.main-container .action-buttons .button {
  padding: 8px 24px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  outline: none;
}
.main-container .action-buttons .button.secondary {
  background-color: #f5f5f5;
  color: #666;
}
.main-container .action-buttons .button.secondary:hover {
  background-color: #e0e0e0;
}
.main-container .action-buttons .button.save-button {
  background-color: #0066b2;
  color: white;
}
.main-container .action-buttons .button.save-button:hover:not(:disabled) {
  background-color: rgb(0, 72.7752808989, 127);
}
.main-container .action-buttons .button.save-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
